import * as d3 from "d3";

type NestedData = {
  id: string
  percent: number
  maxPercent: number
  name?: string
  children?: NestedData[]
  obj?: any
}

let historyStack = [];
// Function to create a bar chart
export function createBarChart(data: NestedData[], idSelector, title, parentData = null) {
  // Clear previous chart

  const svg = d3.select(idSelector);
  const margin = {top: 60, right: 20, bottom: 120, left: 50};  // Adjusted top margin for space above bars
  const width = +svg.attr("width") - margin.left - margin.right;
  const height = +svg.attr("height") - margin.top - margin.bottom;
  svg.selectAll("*").remove();

  // Add a back arrow if there is a parent
  if (parentData) {
      svg.append("text")
          .attr("x", margin.left)
          .attr("y", margin.top / 2)
          .attr("class", "back-arrow")
          .text("← Back")
          .on("click", () => {
              const previousState = historyStack.pop();
              createBarChart(previousState.data, idSelector, previousState.title, previousState.parentData);
          });
  }

  // Add a title to the graph
  svg.append("text")
      .attr("x", (width + margin.left + margin.right) / 2)
      .attr("y", margin.top / 2)
      .attr("class", "title")
      .text(title);

  const x = d3.scaleBand()
      .domain(data.map(d => d.id))
      .range([0, width])
      .padding(0.1);

  const y = d3.scaleLinear()
      .domain([0, d3.max(data, d => d.percent) / 100])
      .nice()
      .range([height, 0]);

  const g = svg.append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

  g.append("g")
      .attr("class", "axis axis--x")
      .attr("transform", `translate(0,${height})`)
      .call(d3.axisBottom(x))
      .selectAll("text")
      .attr("transform", "rotate(-45)")  // Rotate the labels the other way
      .attr("x", -9)  // Adjust x position for the new rotation
      .attr("y", 0)
      .style("text-anchor", "end");

  g.append("g")
      .attr("class", "axis axis--y")
      .call(d3.axisLeft(y).ticks(10, "%"));

  g.selectAll(".bar")
      .data(data)
      .enter().append("rect")
      .attr("class", "bar")
      .attr("x", d => x(d.id))
      .attr("y", d => y(d.percent / 100))
      .attr("width", x.bandwidth())
      .attr("height", d => height - y(d.percent / 100))
      .on("click", function(event, d) {
        console.log(d.obj)
        if (d.children && d.children.length > 0) {
            historyStack.push({ data, title, parentData });
            createBarChart(d.children, idSelector, d.name || d.id, { data, title });
        }
      })
      .append("title")
      .text(d => d.percent);

  g.selectAll(".text")
      .data(data)
      .enter().append("text")
      .attr("class", "label")
      .attr("x", d => x(d.id) + x.bandwidth() / 2)
      .attr("y", d => y(d.percent / 100) - 20) // Position the label above the bar
      .attr("dy", "-.35em") // Adjust the label position
      .text(d => `${d.percent}%`);
  g.selectAll(".text")
    .data(data)
    .enter().append("text")
    .attr("class", "label")
    .attr("x", d => x(d.id) + x.bandwidth() / 2)
    .attr("y", d => y(d.percent / 100) - 2) // Position the label above the bar
    .attr("dy", "-.35em") // Adjust the label position
    .text(d => `(${d.maxPercent}%)`);
}